$(document).ready(function(){

  // update the image

  function updateimage(){
    var selectedfabrictype = "";
    $(".fabric_type .fabric_type_inner").each(function(){
      if($(this).hasClass("active")){
        selectedfabrictype = $(this).attr("data-tab");
      }
    })
   // console.log("selectedfabrictype="+selectedfabrictype);

    var selectedfabric = $(".fabric_colors_inner_type.active .fabric_colors.active .tab_content_title").attr("data-fabrictitle"); 
  //  console.log("selectedfabric=="+selectedfabric);

    var selectedsleevelength = $(".sleeve_lengths.active .tab_content_title").attr("data-lengthtitle");
   // console.log("selectedsleevelength=="+selectedsleevelength);

    var selecteddresslength = $(".dress_lengths.active .tab_content_title").attr("data-dresslengthtitle");
  //  console.log("selecteddresslength=="+selecteddresslength);

    var selectedsize = $(".tab_content_size.active").attr("data-label");
   // console.log("selectedsize=="+selectedsize);

    var finalalttag = selectedfabrictype+"_"+selectedfabric+"_"+selectedsleevelength+"_"+selecteddresslength;
   // console.log("finalalttag="+finalalttag);

    $("ul.product-thumbnails__list li.product-thumbnails__item").each(function(){
      var imagealt = $(this).attr("data-alt");
      if(imagealt == finalalttag){
        $(this).siblings("li.product-thumbnails__item").removeClass("enabledthumb");
        $(this).addClass("enabledthumb");
        $(this).children("button").trigger("click");
        var cuuimage = $(this).children("button").children(".image").children(".mobilethumbimages").attr("data-original");
        $("body.template-product.custom-design .mobile_media_gallery").html("<img src='"+cuuimage+"'>");
      }
    })
    var prod_price = $(".product-page-wrapper .custom_design_feature+form .product__price.type-body-regular").html();
    $(".product_price").html(prod_price);
  }
// Fabric values fetch from variant dropdown starts here
  var fabrichtml = '';
  var checkentry = 0;
  $('.product-form__option-chip[data-label="Fabric"] button.product-form__chip').each(function(){
    var fabricvalue = $(this).attr("aria-label");
    if(checkentry == 0){
      checkentry = parseInt(checkentry)+1;
      fabrichtml = '<div class="fabric_type_inner active" data-tab="'+fabricvalue+'">'+fabricvalue+'</div>';
    }
    else{
      fabrichtml = fabrichtml+'<div class="fabric_type_inner" data-tab="'+fabricvalue+'">'+fabricvalue+'</div>';
    }
  })
  $(".fabric_type .fabric_type_inner").remove();
 // console.log("fabrichtml"+fabrichtml);
  $($.parseHTML(fabrichtml+"<p></p>" )).appendTo(".fabric_type");
  
// Fabric colors fetch from block settings starts here
  $(".fabric_colors_outer .fabric_colors_inner_type").remove();
  $(".fabric_type_inner").each(function(){
    var fabric_type = $(this).attr("data-tab");
    $('.custom_design_fabrics .fabric_colors_inner_type[data-tab="'+fabric_type+'"]').clone().appendTo(".fabric_colors_outer");
  })
  var activefabrictype = $(".fabric_type .fabric_type_inner.active").attr("data-tab");
  $(".fabric_colors_outer .fabric_colors_inner_type[data-tab='"+activefabrictype+"']").addClass("active");

// Sleeve length fetch from block settings starts here
  $('.design_tabs_content_inner[data-tab="data_sleevelength"] .sleeve_lengths').remove();
  $($(".custom_design_sleevelength").html()).appendTo('.design_tabs_content_inner[data-tab="data_sleevelength"]');

// Dress length fetch from block settings starts here
  $('.design_tabs_content_inner[data-tab="data_dress_length"] .dress_lengths').remove();
  $($(".custom_design_dresslength").html()).appendTo('.design_tabs_content_inner[data-tab="data_dress_length"]');

// Dress sizes fetch from block settings starts here
  $('.design_tabs_content_inner[data-tab="data_size"] .tab_content_size').remove();
  $($(".custom_design_sizes").html()).appendTo('.design_tabs_content_inner[data-tab="data_size"]');

// Tabs headings click, show respective content  
  $(".design_tabs_headlines .design_tabs_titles").click(function(){
    if($(this).hasClass("active")){}
    else{
      $(this).siblings(".design_tabs_titles").removeClass("active");
      $(this).addClass("active");

      var datatab = $(this).attr("data-tab");
      $(".design_tabs_content_outer .design_tabs_content_inner").removeClass("active");
      $(".design_tabs_content_outer .design_tabs_content_inner[data-tab='"+datatab+"']").addClass("active");
    }
  })

// Show respective fabric colors based on fabric type click fetched from section blocks
  $(".fabric_colors").click(function(){
    if($(this).hasClass("active")){ }
    else{
      $(this).siblings(".fabric_colors").removeClass("active");
      $(this).addClass("active");
    }
    updateimage();
  })

// Show respective size options fetched from section blocks
  $(".tab_content_size").click(function(){
    if($(this).hasClass("active")){ }
    else{
      $(this).siblings(".tab_content_size").removeClass("active");
      $(this).addClass("active");
    }
  })


// Get fabric type and trigger the variant select box
  var getselectedfabric = $(".fabric_type .fabric_type_inner.active").attr("data-tab");
  $('.product-form__option-chip[data-label="Fabric"] button.product-form__chip[aria-label="'+getselectedfabric+'"]').trigger('click');

  $(".fabric_type_inner").click(function(){
    if($(this).hasClass("active")){ }
    else{
      $(this).siblings(".fabric_type_inner").removeClass("active");
      $(this).addClass("active");
      var datatab = $(this).attr("data-tab");
      $(".fabric_colors_outer .fabric_colors_inner_type").removeClass("active");
      $(".fabric_colors_outer .fabric_colors_inner_type[data-tab='"+datatab+"']").addClass("active");
      $('.product-form__option-chip[data-label="Fabric"] button.product-form__chip[aria-label="'+datatab+'"]').trigger('click');
    }
    updateimage();
  })

// Get Sleeve length and trigger the variant select box
  var getselectedsleevelength = $(".sleeve_lengths.active").attr("data-label");
  $('.product-form__option-chip[data-label="Sleeve length"] button.product-form__chip[aria-label="'+getselectedsleevelength+'"]').trigger('click');

  $(".sleeve_lengths").click(function(){
    if($(this).hasClass("active")){ }
    else{
      $(this).siblings(".sleeve_lengths").removeClass("active");
      $(this).addClass("active");
      var getselectedsleevelength = $(this).attr("data-label").toString().toLowerCase();
      $('.product-form__option-chip[data-label="Sleeve length"] button.product-form__chip').each(function(){
        var getselectedsleevelength1 = $(this).attr("aria-label").toString().toLowerCase();
        if(getselectedsleevelength1 == getselectedsleevelength){
          $(this).trigger("click");
        }
      })
    }
    updateimage();
  })

// Get Dress length and trigger the variant select box
  var getselecteddresslength = $(".dress_lengths.active").attr("data-label");
  $('.product-form__option-chip[data-label="Dress length"] button.product-form__chip[aria-label="'+getselecteddresslength+'"]').trigger('click');

  $(".dress_lengths").click(function(){
    if($(this).hasClass("active")){ }
    else{
      $(this).siblings(".dress_lengths").removeClass("active");
      $(this).addClass("active");

      var getselecteddresslength = $(this).attr("data-label").toString().toLowerCase();
      $('.product-form__option-chip[data-label="Dress length"] button.product-form__chip').each(function(){
        var getselecteddresslength1 = $(this).attr("aria-label").toString().toLowerCase();
        if(getselecteddresslength1 == getselecteddresslength){
          $(this).trigger("click");
        }
      })
    }
    updateimage();
  })

  $(".create_your_dress").click(function(){
    $(this).siblings(".custom_design_feature").slideDown();
    $(this).hide();

    updateimage();

    $(".product__description.rte, .accordion.accordion--active").hide();
    
  })
   
  // variant selection 
  
  $("#final_atc").click(function() {
    $(this).addClass("clicked");

    var selectedfabrictype = "";
    $(".fabric_type .fabric_type_inner").each(function(){
      if($(this).hasClass("active")){
        selectedfabrictype = $(this).attr("data-tab");
      }
    })

    var selectedfabric = $(".fabric_colors_inner_type.active .fabric_colors.active .tab_content_title").attr("data-fabrictitle"); 

    var selectedsleevelength = $(".sleeve_lengths.active .tab_content_title").attr("data-lengthtitle");

    var selecteddresslength = $(".dress_lengths.active .tab_content_title").attr("data-dresslengthtitle");

    var selectedsize = $(".tab_content_size.active").attr("data-label");
    
    var getvariantid = $(".product-form__variants select").val();
        $.ajax({
          url: "/cart/add.js",
          type: "POST",
          dataType: "json",
          data: {
            quantity: 1,
            id: getvariantid,
            properties: {
              "Fabric Type": selectedfabrictype,
              "Fabric Colour": selectedfabric,
              "Sleeve Length": selectedsleevelength,
              "Dress Length": selecteddresslength,
              "Size": selectedsize,
            }
          },
          success: function() {
            window.location.href="/cart";
          },
          error: function(XMLHttpRequest, textStatus, errorThrown) {
            console.error("Error: " + errorThrown);
          }

        });
  });

  $(".zoom_print").click(function(){
    var getimgsrc = $(this).siblings(".fabric_colors_inner_type.active").children(".fabric_colors.active").children(".tab_content_image").children("img").attr("src");
    $(".zoomed_image img").attr("src",getimgsrc);
    //$(".zoomed").removeClass("zoomed");
  //  $(this).siblings(".fabric_colors_inner_type.active").addClass("zoomed");
    $(".zoomed_image").toggle();
    $(".fabric_colors_inner_type.active").hide();
  })
  $(".close_icon_zoomed").click(function(){
    //$(this).parents(".fabric_colors_inner_type.active.zoomed").removeClass("zoomed");
    $(".zoomed_image").hide();
    $(".fabric_colors_inner_type.active").show();
  })

  var getcurrentimage = $("body.template-product.custom-design .custom_design_thumbnails button.product-thumbnails__item-link.active img.mobilethumbimages").attr("data-original");
  $("body.template-product.custom-design .mobile_media_gallery").html("<img src='"+getcurrentimage+"'>");
  $("body.template-product.custom-design img.mobilethumbimages").click(function(){
    var getcurrentimage = $(this).attr("data-original");
  $("body.template-product.custom-design .mobile_media_gallery").html("<img src='"+getcurrentimage+"'>");
  })

  $(".next_step").click(function(){
    if($(".design_tabs_titles[data-tab='data_size']").hasClass("active")){
        $("div#final_atc").trigger("click");
      }
    $(".design_tabs_titles.active").next().trigger("click");
    
  })

  $(".prev_step").click(function(){
    $(".design_tabs_titles.active").prev().trigger("click");
  })
  
})